import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/amelie-snowdon.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/anders-blomqvist.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/anders-jarlskog.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/bert-nordberg.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/fredrik-hedlund.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/marcus-pramgard.png");
;
import(/* webpackMode: "eager" */ "/app/src/assets/team/pierre-jarlskog.png");
